var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["destroyAllMenuMobile"]: () => (__WEBPACK_EXTERNAL_MODULE__static_kuik_menu_mobile_menu_mobile_js_cbcf672c__.destroyAllMenuMobile), ["initAllMenuMobile"]: () => (__WEBPACK_EXTERNAL_MODULE__static_kuik_menu_mobile_menu_mobile_js_cbcf672c__.initAllMenuMobile) });